import React ,{ useEffect, useRef } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import { IFilterCompte, getDefaultFilterCompte } from "../../../models/interfaces/IFilterCompte";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { validationMode } from "../../../config/helpers";
import CpntFilterButtons from "../../../components/CpntFilterButtons";


interface IProps {
  filter?: IFilterCompte;
  changeFilter: (data: IFilterCompte) => void;
}


//Arrive pas a faire passer unb param au parent...
const ComptesFilter: React.FC<IProps> = ({ filter, changeFilter }) => {

  const prevFilterRef = useRef<IFilterCompte | undefined>(filter);

  useEffect(() => {
    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }
    prevFilterRef.current = filter;
  }, [filter]);

  
  const formMethods = useForm<IFilterCompte>({
    defaultValues: getDefaultFilterCompte(),
  });

  const { handleSubmit, reset,getValues } = formMethods;


  const handleResetForm = () => {
    localStorage.removeItem("IFilterComptes");
    changeFilter(getDefaultFilterCompte());
    reset(getDefaultFilterCompte()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };
  

  const onSubmit = (data: IFilterCompte) => {
    changeFilter(data);
    localStorage.setItem("IFilterComptes",JSON.stringify(data)); //need ??
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      //SubmitButton.current.click();
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6, 12]}>
            <TextInput
              label="Nom prénom"
              formName="NomPrenom"
              validationStyle={validationMode.none}
              placeholder="Nom prénom"
            />
            <TextInput
              label="Email"
              formName="Email"
              validationStyle={validationMode.none}
              placeholder="Email"
            />
             <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default ComptesFilter;
